// @flow
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@locus-taxy/neo-ui';

import useControlProps from 'platform/settings/form/renderers/util/useControlProps';

type Props = {
    children: React.Node
};

const FieldWrapper = ({ children, ...rest }: Props): React.Node => {
    const [isHighlighted, setIsHighlighted] = React.useState<boolean>(false);

    const wrapperRef = React.useRef<HTMLElement | null>(null);

    const { path: currentSetting, visible } = useControlProps(rest);
    const location = useLocation();

    const query = new URLSearchParams(location.search);
    const settingToHighlight = query.get('setting');

    React.useEffect(() => {
        if (settingToHighlight !== currentSetting) {
            setIsHighlighted(false);
            return;
        }

        wrapperRef.current?.scrollIntoView();

        setIsHighlighted(true);

        // Clear the highlight styles after sometime.
        const timerId = setTimeout(() => {
            setIsHighlighted(false);
        }, 5000);

        return () => {
            clearTimeout(timerId);
        };
    }, [currentSetting, settingToHighlight]);

    return (
        visible && (
            <Box
                ref={wrapperRef}
                padding={1}
                border={1}
                borderRadius={4}
                borderStyle="solid"
                borderColor={isHighlighted ? 'blue.400' : 'transparent'}
                sx={{
                    transition: 'border ease-out 300ms'
                }}
            >
                {children}
            </Box>
        )
    );
};

export default FieldWrapper;
